
  
<div class="container-fluid">
    <div class="container">
        <section class="slider" style="padding-bottom: 40px;">
            <div class="bg"  >
                <div class="row justify-content-center">
                    <div class="card single-card">
                        <div class="card-body">
                            <h2 class="card-title">Lorem ipsum dolor sit amet.</h2>
                            <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum deleniti officiis qui, omnis voluptate asperiores. Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero molestiae numquam quasi nisi nemo nostrum?</p>
                        </div>
                    </div>
                  
                        <div class="col-md-4 col-lg-4">
                            <div class="card">
                                <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/uno.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                    
                                </div>
                            </div>
                        </div>
                       
                        <div class="col-md-4 col-lg-4">
                            <div class="card">
                                <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/dos.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                     <h5 class="card-title">Card title</h5>
                                        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                     <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-4">
                            <div class="card">
                                <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/tres.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                     <h5 class="card-title">Card title</h5>
                                        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                     <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                    
                                </div>
                            </div>
                        </div>
                </div>
            </div>
            <div>
                <div class="row justify-content-center">
                    <div class="card single-card">
                        <div class="card-body">
                            <h2 class="card-title">Lorem ipsum  sit amet.</h2>
                            <p class="card-text">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Impedit ut sit temporibus doloribus ducimus ab, quod dolores asperiores harum enim! Officiis vitae corrupti culpa possimus nobis recusandae maiores corporis accusamus.</p>
                        </div>
                    </div>
                        <div class="col-md-4">
                            <div class="card">
                                <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/cuatro.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                     <h5 class="card-title">Card title</h5>
                                    <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                     <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                    
                                </div>
                            </div>
                        </div>
                       
                        <div class="col-md-4">
                            <div class="card">
                                 <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/cinco.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                     <h5 class="card-title">Card title</h5>
                                    <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                     <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                    
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card">
                                 <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/seis.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                    
                                </div>
                            </div>
                     </div>
                </div>
            </div>
            <div>
                <div class="row justify-content-center">
                    <div class="card single-card">
                        <div class="card-body">
                            <h2 class="card-title">Lorem ipsum dolor sit amet consectetur adipisicing.</h2>
                            <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Harum tenetur dolore magni accusamus, perspiciatis fuga fugiat dolores enim corrupti ab corporis amet nam ut tempore?</p>
                        </div>
                    </div>
                        <div class="col-md-4">
                            <div class="card">
                                <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/siete.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title">Card title</h5>
                                    <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                </div>
                            </div>
                        </div>
                       
                        <div class="col-md-4">
                            <div class="card">
                              <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/ocho.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                     <h5 class="card-title">Card title</h5>
                                     <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="card">
                              <div class="contenedor">
                                    <figure>
                                        <img src="../../../../assets/img/images/nueve.jpg" class="card-img-top" alt="...">
                                        <div class="capa"></div>
                                    </figure>
                                    <div class="text1">Desing</div>
                                </div>
                                <div class="card-body">
                                     <h5 class="card-title">Card title</h5>
                                     <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                                    
                                </div>
                            </div>
                     </div>
                </div>
            </div>
                
          </section>
    
    </div>
</div>
   